import {
  CardContent,
  Grid,
  ListItem,
  ListItemText,
  Typography,
  useEventCallback,
} from '@mui/material';
import { Link } from 'react-router-dom';
import { useActionAuthorization } from 'shell/hooks/use-action-authorization';
import { PmiCard } from 'shell/components/shared/card';
import PmiTitle from 'shell/components/shared/title';
import {
  CancellationAireAuthorizations,
  CancellationDeathAuthorizations,
} from 'shell/authorizations/cancellations';
import { Fragment, useState } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonCancellationsCrumbs } from 'cancellations/constants/breadcrumb';
import CardMenu from './card-menu';

const HomePage = (): React.ReactElement => {
  const actions = useActionAuthorization({
    cancellazionePerMorte: CancellationDeathAuthorizations,
    cancellazioneAire: CancellationAireAuthorizations,
  });

  const [cardSubmenuAnchor, setCardSubmenuAnchor] = useState<null | HTMLElement>(null);

  const isCardSubmenuVisible = Boolean(cardSubmenuAnchor);

  const handleCardMenuClick = useEventCallback((event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setCardSubmenuAnchor(event.currentTarget);
  });

  const handleCardSubmenuClose = useEventCallback((event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    setCardSubmenuAnchor(null);
  });

  return (
    <Fragment>
      <Breadcrumbs items={CommonCancellationsCrumbs} />
      <PmiTitle title="Cancellazioni" paddingBottom={1} />
      <div className="pmi-mb-4">
        <Typography component="div" fontSize=".9rem" color="primary">
          {"Seleziona l'area su cui iniziare ad operare"}
        </Typography>
      </div>
      <Grid container spacing={2}>
        {actions.cancellazionePerMorte ? (
          <Grid item xs={12} md={4}>
            <Link to="/cancellazioni/cancellazione-per-morte" className="pmi-anchor">
              <PmiCard>
                <CardContent>
                  <ListItem>
                    <ListItemText primary="Cancellazione per Morte" />
                  </ListItem>
                </CardContent>
              </PmiCard>
            </Link>
          </Grid>
        ) : undefined}
        {!actions.cancellazioneAire ? undefined : (
          <Grid item xs={12} md={4}>
            <PmiCard onClick={handleCardMenuClick}>
              <CardContent>
                <CardMenu
                  visibility={{
                    perditaCittadinanza: actions.cancellazioneAire,
                    irreperibilitaPresunta: actions.cancellazioneAire,
                  }}
                  isSubmenuVisible={isCardSubmenuVisible}
                  onClick={handleCardMenuClick}
                  onClose={handleCardSubmenuClose}
                  submenuAnchor={cardSubmenuAnchor}
                />
              </CardContent>
            </PmiCard>
          </Grid>
        )}
        {/* {actions.iscrizioneAireCitizenship ? ( */}
        {/* <Grid item xs={12} md={4}>
          <Link to="/cancellazioni/notifiche-da-stato-civile" className="pmi-anchor">
            <PmiCard>
              <CardContent>
                <ListItem>
                  <ListItemText primary="Registrazione S.C. - ANAGRAFE" />
                </ListItem>
              </CardContent>
            </PmiCard>
          </Link>
        </Grid> */}
        <Grid item xs={12} md={4}>
          <Link to="/cancellazioni/notifiche/ansc" className="pmi-anchor">
            <PmiCard>
              <CardContent>
                <ListItem>
                  <ListItemText primary="Aggiornamento anagrafe da ANSC" />
                </ListItem>
              </CardContent>
            </PmiCard>
          </Link>
        </Grid>
        {/* ) : undefined} */}
        <Grid item xs={12} md={4}>
          <Link to="/cancellazioni/non-residenti" className="pmi-anchor">
            <PmiCard>
              <CardContent>
                <ListItem>
                  <ListItemText primary="Cancellazione per Morte Non Residenti" />
                </ListItem>
              </CardContent>
            </PmiCard>
          </Link>
        </Grid>
        <Grid item xs={12} md={4}>
          <Link to="/cancellazioni/minori" className="pmi-anchor">
            <PmiCard>
              <CardContent>
                <ListItem>
                  <ListItemText primary="Cancellazione Minori" />
                </ListItem>
              </CardContent>
            </PmiCard>
          </Link>
        </Grid>
      </Grid>
    </Fragment>
  );
};

HomePage.displayName = 'home page component';

export default HomePage;
